import "./Products.css";
import axios from "axios";
import Qs from "qs";
import React from "react";
import { useState, useEffect } from "react";
import ProductThumb from "./ProductThumb";
import Footer from "../components/Footer";
import Category from "../components/Category";
import { Card } from "react-bootstrap";
import { hideNavAction } from "../store/actions/showNavAction";
import { useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";

function Products() {
  const [products, setProducts] = useState([]);
  const [productsCache, setProductsCache] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoriesSelected, setCategoriesSelected] = useState([]);
  const [categoriesAreLoaded, setCategoriesAreLoaded] = useState(false);
  const [productsAreLoaded, setProductsAreLoaded] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const productsURL = process.env.REACT_APP_API_URL + `/products`;
    const categoriesURL = process.env.REACT_APP_API_URL + `/categories`;
    console.log(productsURL);

    const fetchAllProducts = async () => {
      const productsData = await axios({
        method: "GET",
        url: productsURL,
      });
      setProducts(productsData.data);
      setProductsCache(productsData.data);
      setProductsAreLoaded(true);
    };
    const fetchCategoriesData = async () => {
      try {
        const categoriesData = await axios({
          method: "GET",
          url: categoriesURL,
        });
        setCategories(categoriesData.data);
        setCategoriesAreLoaded(true);
      } catch (error) {
        console.log(error);
      }
    };
    const fetchProductsByCategory = async () => {
      console.log("Entro aca!");
      const products = await axios({
        method: "GET",
        url: process.env.REACT_APP_API_URL + `/products`,
        params: {
          categories: categoriesSelected,
        },
        paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: "brackets" }),
      });
      console.log("Resultado : ", products.data);
      setProducts(products.data);
    };
    console.log("CATEGORIAS SELECCIONADAS : ", categoriesSelected);
    if (categoriesSelected.length === 0) {
      fetchAllProducts();
    } else {
      fetchProductsByCategory();
    }

    fetchCategoriesData();
    window.scrollTo(0, 0);
    dispatch(hideNavAction());
  }, [categoriesSelected]);

  return (
    <>
      <div className="container">
        <div className="row mt-5 ">
          <div className="col-lg-3 mt-3 py-4">
            {!categoriesAreLoaded ? (
              <div className="d-flex align-items-center justify-content-center pt-4 pb-4">
                <Spinner
                  animation="border"
                  role="info"
                  style={{ color: "rgb(119, 33, 33)" }}
                ></Spinner>
                <p
                  className="ps-2 m-0"
                  style={{ color: "rgb(119, 33, 33)", fontFamily: "'Lobster Two', cursive" }}
                >
                  Cargando filtros...
                </p>
              </div>
            ) : (
              <Category
                categories={categories}
                categoriesSelected={categoriesSelected}
                setCategoriesSelected={setCategoriesSelected}
              />
            )}
          </div>
          <div className="col-lg-9 mt-3 py-4">
            {!productsAreLoaded ? (
              <div className="d-flex align-items-center justify-content-center pt-4 pb-4">
                <Spinner
                  animation="border"
                  role="info"
                  style={{ color: "rgb(119, 33, 33)" }}
                ></Spinner>
                <p
                  className="ps-2 m-0"
                  style={{ color: "rgb(119, 33, 33)", fontFamily: "'Lobster Two', cursive" }}
                >
                  Cargando Productos...
                </p>
              </div>
            ) : (
              <Card>
                <Card.Header style={{ fontFamily: "'Lobster Two', cursive" }}>
                  <div className="row align-items-center">
                    <div className="col-lg-6">
                      <img
                        src="https://www.svgrepo.com/show/119699/wine-bottles-on-a-rack.svg"
                        intrinsicsize="512 x 512"
                        width="40"
                        height="40"
                        srcSet="https://www.svgrepo.com/show/119699/wine-bottles-on-a-rack.svg 4x"
                        alt="Wine Bottles On A Rack SVG Vector"
                        title="Wine Bottles On A Rack SVG Vector"
                      />
                      <span className="ps-2 fs-4">Resultados : {products.length}</span>
                    </div>
                    <div className="col-lg-6">
                      <form className="">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Buscar"
                          aria-label="Buscar"
                          onChange={(e) =>
                            setProducts(
                              productsCache.filter((p) =>
                                p.name.toLowerCase().includes(e.target.value.toLowerCase()),
                              ),
                            )
                          }
                        />
                      </form>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body className="p-5">
                  <div className="row">
                    {products.map((product) => (
                      <div className="col-md-4">
                        <ProductThumb
                          product={product}
                          key={product._id}
                          className="text-decoration-none"
                        />
                      </div>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Products;
